//node_modules
import React, { FunctionComponent } from "react";
import { NextSeo } from "next-seo";

//helpers
import getImageLoaderAbsoluteSrc from "@adjust/website/libs/helper/getImageLoaderAbsoluteSrc";

//hooks
import useCanonical from "@adjust/src/hooks/useCanonical";

const title = "Services we Provide - Adjust to the Good Life Travel";
const description = "A list of services that our Travel Agents can help with!";

const MetaComponent: FunctionComponent = () => {
  const canonical = useCanonical();
  const src = getImageLoaderAbsoluteSrc("/images/97b9375cf75ade65090bccc8c8ef5884.png", 1200);

  return (
    <NextSeo
      title={title}
      description={description}
      canonical={canonical}
      noindex={false}
      nofollow={false}
      openGraph={{
        type: "website",
        siteName: "Adjust to the Good Life Travel",
        url: canonical,
        title: title,
        description: description,
        images: [
          {
            url: src,
          },
        ],
      }}
      twitter={{
        cardType: "summary_large_image",
      }}
    />
  );
};

export default React.memo(MetaComponent);
